<user-authorisations-mobile *ngIf="isMobile"></user-authorisations-mobile>
<user-authorisations-desktop *ngIf="!isMobile"></user-authorisations-desktop>